export default {"src":"/_next/static/media/course_icon.c6453de2.svg","height":284,"width":284};